module.exports = __webpack_public_path__ + "0f4dcc75b23576fab180c01b1b7e23ef.jpg";